module.exports = __webpack_public_path__ + "images/shimo/form-new-ba99224ee33c54f0e2d2aa2270d7ce09.png";